export default __webpack_public_path__ + "f81480118005fb0730e27ab3458ae4ea.png";